import Api_Usermanagement from '../api-usermanagement'
import Api_Usermanagement_V2 from '../api-usermanagement-v2'

const api = new Api_Usermanagement().init()
const api_mng_v2 = new Api_Usermanagement_V2().init()

const createSO = (data) => {
  return api.post(`/sales-order/create`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllSO = (credential, filter, cus) => {
  return api.get(
    `/sales-order?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getDetailContract = (id, credential) => {
  return api.get(`/contract/detail/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSODetailContract = (id, credential) => {
  return api.get(`/contract/detail-for-so/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailSO = (id, credential) => {
  return api.get(`/sales-order/detail/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const printSO = (id) => {
  return api.get(`/sales-order/print/so/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const approveSO = (id, cred, data, lang = 'en') => {
  return api.put(`/sales-order/approve/${id}/${lang}?credentials=${cred}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const resubmitSO = (id, cred, data, lang = 'en') => {
  return api_mng_v2.put(`/sales-order/resubmit/${id}?lang=${lang}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Credentials': cred,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rejectSO = (id, data) => {
  return api.put(
    `/sales-order/revision-reject/90/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const revisionSO = (id, data) => {
  return api.put(
    `/sales-order/revision-reject/2/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPaymentSO = (id) => {
  return api.get(`/sip_order/payment-type/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllApprovalSO = (credential) => {
  return api.get(`/sales-order?status=1&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}
const getAccesses = (id) => {
  return api.get(`/role-access/detail/${id}/138`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllSearch = (
  credential,
  so,
  sap,
  incoterm,
  sector,
  sales,
  order_code,
  quantum,
  date,
  date2,
  status,
  po,
  buyer,
  totalPriceSO,
  sipNumber,
  price_after_ppn,
  product_type,
  payment_type
) => {
  return api.get(
    `/sales-order?credentials=${credential}&so_number=${so}&sap_number=${sap}&incoterm=${incoterm}&sector_id=${sector}&sales_org_code=${sales}&booking_code=${order_code}&total_quantum_so=${quantum}&from_date=${date}&to_date=${date2}&status=${status}&po_number=${po}&customer_name=${buyer}&total_price_so=${totalPriceSO}&sip_number=${sipNumber}&price_after_ppn=${price_after_ppn}&product_type=${product_type}&payment_type=${payment_type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAttachment = (id, credential) => {
  return api.get(`/attachment/all/sales-order?attach_parent=${id}&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const postAttachment = (data) => {
  return api.post(`/attachment/create/sales-order`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllSOApproval = (credential, filter, cus, checked = '') => {
  return api.get(
    `/sales-order/get-otorisator${checked}?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAllSOSearch = (
  credential,
  so,
  incoterm,
  sector,
  sales,
  quantum,
  date,
  date2,
  status,
  po,
  sip,
  buyer,
  checked = '',
  total_price_so,
  booking_code,
  sap_number
) => {
  return api.get(
    `/sales-order/get-otorisator${checked}?credentials=${credential}&so_number=${so}&incoterm=${incoterm}&sector_id=${sector}&sales_org_code=${sales}&total_quantum_so=${quantum}&from_date=${date}&to_date=${date2}&status=${status}&po_number=${po}&sip_number=${sip}&customer_name=${buyer}&total_price_so=${total_price_so}&booking_code=${booking_code}&sap_number=${sap_number}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const editSOItem = (id, data) => {
  return api.put(
    `/sales-order/so-item/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateLastestProduct = (id, data) => {
  return api.put(
    `/sales-order/updated-latest-contact/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateDueDate = (id, data) => {
  return api.put(
    `/sales-order/update-payment-due-date/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const sentToSAP = (id) => {
  return api.post(
    `/sales-order/resend-so-to-sap/${id}`,
    {credentials: localStorage.getItem('credential')},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const download = (params) => {
  return api.get(
    `/sales-order/export`,
    {params},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const soItemEdit = (id) => {
  return api.get(`/sales-order/so-item/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const cancelSO = (id) => {
  return api.put(
    `/sales-order/cancel/${id}?credentials=${localStorage.getItem('credential')}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const cancelAmend = (id) => {
  return api.post(
    `/sip_order/cancel/${id}?credentials=${localStorage.getItem('credential')}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const syncSO = (data) => {
  return api.post(`/sales-order/sync`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCommentSO = (id) => {
  return api.get(`/comment/${id}/so_notes?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const updateAdditionalText = (id, data) => {
  return api.put(
    `/sales-order/update-additional-text/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const unduhSO = (id, lang) => {
  return api.get(`/sales-order/download/so/${id}?lang=${lang}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  createSO,
  getAllSO,
  getDetailContract,
  getDetailSO,
  printSO,
  approveSO,
  rejectSO,
  getPaymentSO,
  getAllApprovalSO,
  getAccesses,
  getAllSearch,
  getAttachment,
  postAttachment,
  getAllSOApproval,
  getAllSOSearch,
  editSOItem,
  updateLastestProduct,
  sentToSAP,
  download,
  soItemEdit,
  getSODetailContract,
  updateDueDate,
  cancelSO,
  cancelAmend,
  syncSO,
  getCommentSO,
  updateAdditionalText,
  revisionSO,
  resubmitSO,
  unduhSO
}
